import React from 'react';

export default ({ show }) => {
  return show ? <span className="fa fa-spinner fa-spin"></span> : null
}
